const { useSelector } = require("react-redux")
const { useFirestoreConnect } = require("react-redux-firebase")

export default function useCustomerData() {
  const auth = useSelector((state) => state.firebase.auth)

  useFirestoreConnect([
    {
      collection: "customers",
      doc: `${auth?.uid}`,
      storeAs: "addressList",
      subcollections: [{ collection: "address" }],
    },
    {
      collection: "customers",
      doc: `${auth?.uid}`,
      storeAs: "customer",
    },
    {
      collection: "stripe_customers",
      doc: `${auth?.uid}`,
      subcollections: [{ collection: "payment_methods" }],
      storeAs: "paymentMethods",
    },
    {
      collection: "stripe_customers",
      doc: `${auth?.uid}`,
      storeAs: "stripeCustomer",
    },
  ])

  const customer = useSelector(({ firestore: { data } }) => {
    return data?.customer
  })

  const addressList = useSelector(({ firestore: { data } }) =>
    Object.keys(data?.addressList || {}).map((key) => ({
      ...data?.addressList?.[key],
      id: key,
    }))
  )

  const paymentMethods = useSelector(({ firestore: { data } }) =>
    Object.keys(data?.paymentMethods || {}).map((key) => ({
      ...data?.paymentMethods?.[key],
      id: key,
    }))
  )

  const stripeCustomer = useSelector(({ firestore: { data } }) => {
    return data?.stripeCustomer
  })

  return { customer, auth, addressList, paymentMethods, stripeCustomer }
}
